module.exports = __webpack_public_path__ + "img/熊猫匠心二期详情.8b445f98.jpg";